import Swal from "sweetalert2";

import {
  Avatar,
  Button,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import Resizer from "react-image-file-resizer";
import { useMaterialUIController } from "context";
import { useEffect, useRef, useState } from "react";
import getText from "Translator";
import { setLoading } from "context";
import { getProfile } from "controllers/UserController";
import { getCountries } from "controllers/UserController";
import { getSpecialities } from "controllers/UserController";
import { completProfile } from "controllers/UserController";
import config from "configs/config";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function Profile(props) {
  const [picture, setPicture] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("1");
  const [gender, setGender] = useState(0);
  const [city, setCity] = useState();
  const [cellphone, setCellphone] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [nationalityList, setNationalityList] = useState([]);
  const [nationality, setNationality] = useState("");
  const [specialityList, setSpecialityList] = useState([]);
  const [speciality, setSpeciality] = useState("");

  const [controller, dispatch] = useMaterialUIController();

  const [institution, setInstitution] = useState("");
  const [howToInform, setHowToInform] = useState("");

  const myRef = useRef(null);

  const fileUploader = useRef(null);
  const [file, setFile] = useState("");

  //#region validationInfo
  let isValid = true;
  let message = "";

  const validationInfo = () => {
    // if (validator.isEmpty(jMoment(birthday).format("jYYYY/jMM/jDD"))) {
    //   isValid = false;
    //   message =
    //     message + "لطفا تاریخ تولد خود را وارد نمائید." + "<br>";
    // }

    return isValid;
    setLoading(dispatch, false);
  };
  //#endregion

  const getDatas = async (id) => {
    try {
      setLoading(dispatch, true);

      let result = await getProfile(controller);

      setLoading(dispatch, false);
      let nationalityResult = await getCountries();
      if (nationalityResult.success) {
        setNationalityList(nationalityResult.data);
      }
      let specialityResult = await getSpecialities();
      if (specialityResult.success) {
        setSpecialityList(specialityResult.data);
      }
      setLoading(dispatch, false);
      if (result.success) {
        console.log("resultresultresultresult", result.data);
        setPicture(result.data.picture);
        setName(result.data.name);
        setCode(result.data.code);
        setGender(result.data.gender);
        setCity(result.data.city);
        setAge(result.data.age);
        setNationality(result.data.nationality);
        setSpeciality(result.data.speciality);
        setInstitution(result.data.institution);
        setEmail(result.data.email);
        setCellphone(result.data.cellphone);
        setHowToInform(result.data.howToInform);
      } else {
        Swal.fire({
          title: getText("warning", "fa"),
          text: result.message,
          confirmButtonText: getText("ok", "fa"),
          icon: "error",
        });
      }
    } catch (err) {
      console.log("errrrrr", err);
    }
  };
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });
  const handleSelectFile = async (event) => {
    let newFile = await resizeFile(event.target.files[0]);
    setFile(newFile);
  };

  const submitHandler = async () => {
    // if (file.length < 10 && picture === "") {
    //     Swal.fire({
    //         title: getText('chooseimage', "fa"),
    //         confirmButtonText: getText('ok', "fa"),
    //         icon: "error",
    //     });
    //     return;
    // }

    if (!name || name === "") {
      Swal.fire({
        title: getText("fullnamealert", "fa"),
        confirmButtonText: getText("ok", "fa"),
        icon: "error",
      });
      //this.nameRef._root.focus();
      return;
    }
    // if (!code || code === '') {
    //     Swal.fire({
    //         title: getText('personnelcodealert', "fa"),
    //         confirmButtonText: getText('ok', "fa"),
    //         icon: "error",
    //     });

    //     //this.codeRef._root.focus();
    //     return;
    // }
    if (!institution || institution === "") {
      Swal.fire({
        title: getText("institutionalert", "fa"),
        confirmButtonText: getText("ok", "fa"),
        icon: "error",
      });
      return;
    }

    if (
      age + "" === "undefined" ||
      age + "" === "" ||
      city + "" === "undefined" ||
      city === "" ||
      gender + "" === "undefined" ||
      gender === "" ||
      nationality + "" === "undefined" ||
      nationality === "" ||
      speciality + "" === "undefined" ||
      speciality === ""
    ) {
      Swal.fire({
        title: getText("emptyalert", "fa"),
        confirmButtonText: getText("ok", "fa"),
        icon: "error",
      });
      return;
    }

    let user = {
      name,
      code,
      age,
      gender,
      speciality,
      city,
      howToInform,
      nationality,
      institution,
      email,
    };

    setLoading(dispatch, true);
    let responce = await completProfile(user, file, controller);

    setLoading(dispatch, false);
    if (responce.success) {
      Swal.fire({
        title: responce.message,
        confirmButtonText: getText("ok", "fa"),
        icon: "success",
      });
      props.history.push("/");
    } else {
      if (responce.errorCode === 101) {
        Swal.fire({
          title: "",
          text: getText("warningalert", "fa"),
          confirmButtonText: getText("ok", "fa"),
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "",
          text: getText("warningalert", "fa"),
          confirmButtonText: getText("ok", "fa"),
          icon: "success",
        });
      }
    }

    setLoading(dispatch, false);
  };
  useEffect(() => {
    getDatas();

    if (myRef.current !== null) {
      myRef.current.scrollIntoView();
    }
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("profile", "fa")} />
      <div
        className={"fa" === "en" ? "" : "rtl"}
        style={{ paddingBottom: 100 }}
      >
        {/* <div style={{ width: "100%", height: 35 }} ref={myRef}></div> */}
        <input
          type="file"
          id="file"
          accept="audio/*,video/*,image/*"
          ref={fileUploader}
          onChange={handleSelectFile}
          style={{ display: "none" }}
        />

        <div style={{ marginTop: 50, padding: 10 }}>
          <Grid container>
            <Grid
              item
              key={"x1"}
              xs={12}
              sm={12}
              md={12}
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              <IconButton
                onClick={() => {
                  fileUploader.current.click();
                }}
              >
                <Avatar
                  style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    width: 80,
                    height: 80,
                    border: 2,
                    BorderColor: "#039dfc",
                  }}
                  alt={getText("fullname", "fa")}
                  src={
                    file
                      ? URL.createObjectURL(file)
                      : config.fileserver + "/images/" + picture
                  }
                  className="orange"
                  Ï
                />
              </IconButton>
            </Grid>
            <Grid
              item
              key={"x2"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("fullname", "fa")}</b>
              <TextField
                id="name"
                fullWidth={true}
                value={name}
                variant="outlined"
                onChange={(event) => {
                  setName(event.target.value);
                }}
              ></TextField>
            </Grid>
            <Grid
              item
              key={"x3"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("personnelcode", "fa")}</b>
              <TextField
                id="personnelcode"
                fullWidth={true}
                value={code}
                variant="outlined"
                onChange={(event) => {
                  setCode(event.target.value);
                }}
                type="number"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              ></TextField>
            </Grid>
            <Grid
              item
              key={"x3city"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("city", "fa")}</b>
              <TextField
                id="city"
                fullWidth={true}
                value={city}
                variant="outlined"
                onChange={(event) => {
                  setCity(event.target.value);
                }}
              ></TextField>
            </Grid>
            <Grid
              item
              key={"x6"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("cellnumber", "fa")}</b>
              <TextField
                id="cellnumber"
                variant="outlined"
                fullWidth={true}
                value={cellphone}
                disabled={true}
                onChange={(event) => {
                  setCellphone(event.target.value);
                  // checkCellphone();
                }}
              />
            </Grid>
            <Grid
              item
              key={"x4"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("gender", "fa")}</b>
              <TextField
                id="gender"
                fullWidth={true}
                variant="outlined"
                value={gender}
                select
                onChange={(event) => {
                  setGender(event.target.value);
                }}
              >
                <MenuItem key={0} value={0}>
                  {getText("male", "fa")}
                </MenuItem>
                <MenuItem key={1} value={1}>
                  {getText("female", "fa")}
                </MenuItem>
              </TextField>
            </Grid>
            <Grid
              item
              key={"x8age"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("age", "fa")}</b>
              <TextField
                type="number"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                id="age"
                variant="outlined"
                fullWidth={true}
                value={age}
                onChange={(event) => {
                  setAge(event.target.value);
                }}
              />
            </Grid>

            <Grid
              item
              key={"x4nationality"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("nationality", "fa")}</b>
              <TextField
                id="nationality"
                fullWidth={true}
                variant="outlined"
                value={nationality}
                onChange={(event) => {
                  setNationality(event.target.value);
                }}
              ></TextField>
            </Grid>
            <Grid
              item
              key={"x4speciality"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("speciality", "fa")}</b>
              <TextField
                id="speciality"
                fullWidth={true}
                variant="outlined"
                value={speciality}
                select
                onChange={(event) => {
                  setSpeciality(event.target.value);
                }}
              >
                {specialityList &&
                  specialityList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {"fa" === "fa" ? item.fa : item.en}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid
              item
              key={"x8"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("institution", "fa")}</b>
              <TextField
                id="institution"
                variant="outlined"
                fullWidth={true}
                value={institution}
                onChange={(event) => {
                  setInstitution(event.target.value);
                }}
              />
            </Grid>
            <Grid
              item
              key={"x8email"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
              }}
            >
              <b>{getText("email", "fa")}</b>
              <TextField
                id="email"
                variant="outlined"
                fullWidth={true}
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </Grid>
            <Grid
              item
              key={"x8gettoknow"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 15,
                display: "none",
              }}
            >
              <b>{getText("gettoknow", "fa")}</b>
              <TextField
                id="gettoknow"
                variant="outlined"
                fullWidth={true}
                value={howToInform}
                onChange={(event) => {
                  setHowToInform(event.target.value);
                }}
              />
            </Grid>

            <Grid
              item
              key={"x19"}
              xs={12}
              sm={12}
              md={12}
              style={{
                marginTop: 20,
              }}
            >
              <Button
                color="primary"
                onClick={() => {
                  submitHandler();
                }}
                fullWidth={true}
              >
                {getText("submit", "fa")}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer />
    </DashboardLayout>
  );
}
